// extracted by mini-css-extract-plugin
export default {"avatarStack":"AssigneesMetadata-module__avatarStack__HpIYpRS","avatar":"AssigneesMetadata-module__avatar__NGgwkRL"};